import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-doc-pack-types',
  templateUrl: './doc-pack-types.component.html',
  styleUrls: ['./doc-pack-types.component.css']
})
export class DocPackTypesComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private createGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('docpacktype_grid')
                .setLoadDataFunction({
                    method: 3283,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setCustomToolbarButtons([{
                    name: 'docpacktypes_new',
                    text: 'docpacktypes_new',
                    func: () => this.stateService?.go('docpacktype', { docpacktype_keyno: '0' }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        }
    }

    private async init() {
        this.createGrid();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('docPackTypes', {
//        templateUrl: 'views/components/views/docPackTypes/docPackTypes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'docpacktype_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setLoadDataFunction({
//                method: 3283,
//                parameters: {}
//            }).setCustomToolbarButtons([{
//                name: 'docpacktypes_new',
//                text: 'docpacktypes_new',
//                func: () => stateService.go('docpacktype', { docpacktype_keyno: '0' }),
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);

//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
